<template>
  <div>
    <v-verify-user-banner/>

    <div class="mb-3">
      <v-research-search />
    </div>

    <div class="row">
      <div class="col-lg-9 mb-3">
        <div class="row" v-if="statistics.commercial_count">
          <div class="col-md-4 mb-3">
            <v-statistics-card
              text="phrase.all_commercials"
              type="warning"
              icon="play-circle"
              :route-to="{name: 'commercial-list'}"
              :statistic="statistics.commercial_count"
            />
          </div>
          <div class="col-md-4 mb-3">
            <v-statistics-card
              text="word.reviews"
              type="info"
              icon="check"
              :statistic="statistics.reviews_count"
            />
          </div>
          <div class="col-md-4 mb-3">
            <v-statistics-card
              text="phrase.issued_coins"
              icon="coins"
              type="cr-red"
              :statistic="statistics.coin_count"
            />
          </div>
        </div>

        <div>
          <v-research-set
            v-for="researchSet in researchSets"
            :key="researchSet.uuid"
            :research-set="researchSet"
          />
        </div>
      </div>

      <div class="col-lg-3">
        <div class="mb-3" v-if="organisations">
          <div class="card">
            <router-link
              :to="{ name: 'public-organisation-list', query: { type: 'media_agency' } }"
            >
              <h6 class="card-header with-elements d-flex justify-content-between">
                <div class="card-header-title">
                  <i class="fa fa-handshake text-cr-red mr-2"></i>
                  {{ $tc('word.agency', 2) }}
                </div>
              </h6>
            </router-link>
            <v-organisation-carousel
              :organisations="organisations"
              :per-page="1"
              :autoplay-timeout="2500"
              :speed="500"
            />
          </div>
        </div>
        <div class="mb-3">
          <v-dashboard-articles-card/>
        </div>
      </div>
    </div>

    <v-onboarding-modal
      v-if="showOnboardingWizard"
      @hide-modal="showOnboardingWizard = false"
    />
  </div>
</template>

<script>
import ResearchSearch from '@/common/components/commercials/ResearchSearch.vue';
import DashboardArticlesCard from '@/reviewer/components/DashboardArticlesCard.vue';
import OrganisationCarousel from '@/common/components/carousels/OrganisationCarousel.vue';
import OnboardingModal from '@/common/components/users/OnboardingModal.vue';
import StatisticCard from '@/common/components/StatisticCard.vue';
import ResearchSet from '@/reviewer/components/ResearchSet.vue';
import VerifyUserBanner from '@/common/components/users/VerifyUserBanner.vue';
import { mapActions, mapGetters } from 'vuex';
import { fetchOrganisations, fetchResearchSets } from '@/public/api';

export default {
  name: 'Dashboard',
  data: () => ({
    showOnboardingWizard: false,
    researchSets: [],
    organisations: null,
  }),
  components: {
    'v-research-search': ResearchSearch,
    'v-dashboard-articles-card': DashboardArticlesCard,
    'v-organisation-carousel': OrganisationCarousel,
    'v-onboarding-modal': OnboardingModal,
    'v-research-set': ResearchSet,
    'v-statistics-card': StatisticCard,
    'v-verify-user-banner': VerifyUserBanner,
  },
  methods: {
    ...mapActions('sites', [
      'getStatistics',
    ]),
    async fetchResearchSets() {
      const response = await fetchResearchSets();
      if (response.status === 200) {
        this.researchSets = response.data;
      }
    },
    async fetchOrganisations() {
      const response = await fetchOrganisations('media_agency', true, true);
      if (response.status === 200) {
        this.organisations = response.data.results;
      }
    },
  },
  computed: {
    ...mapGetters('sites', ['statistics']),
    ...mapGetters(['user']),
  },
  created() {
    if (this.user.username && !this.user.is_onboarded) {
      this.showOnboardingWizard = true;
    }

    this.getStatistics();
    this.fetchResearchSets();
    this.fetchOrganisations();
  },
};
</script>
